import { h } from "@stencil/core";
import { fromGxImageToURL } from "../tree-view/genexus-implementation";
const DEFAULT_DROPDOWN_ITEM_CLASS = "dropdown-item";
export class ChDropdownRender {
    constructor() {
        this.buttonLabel = "Show options";
        this.cssClass = "dropdown";
        this.expandBehavior = "ClickOrHover";
        this.gxImageConstructor = undefined;
        this.gxSettings = undefined;
        this.itemClickCallback = undefined;
        this.model = undefined;
        this.openOnFocus = false;
        this.position = "Center_OutsideEnd";
        this.useGxRender = false;
    }
    showHeader = false;
    showFooter = false;
    el;
    // /**
    //  * Fired when the visibility of the dropdown section is changed
    //  */
    // @Event() expandedChange: EventEmitter<boolean>;
    handleItemClick = (target, itemId) => (event) => {
        this.itemClickCallback(event, target, itemId);
    };
    renderItem = (item) => [
        h("ch-dropdown-item", { slot: "items", id: item.id, class: item.class || DEFAULT_DROPDOWN_ITEM_CLASS, expandBehavior: this.expandBehavior, href: item.link?.url, leftImgSrc: this.useGxRender
                ? fromGxImageToURL(item.startImage, this.gxSettings, this.gxImageConstructor)
                : item.startImage, openOnFocus: this.openOnFocus, position: item.itemsPosition || "OutsideEnd_InsideStart", rightImgSrc: this.useGxRender
                ? fromGxImageToURL(item.endImage, this.gxSettings, this.gxImageConstructor)
                : item.endImage, shortcut: item.shortcut, onClick: this.handleItemClick(item.link?.url, item.id) }, item.caption, item.items != null && item.items.map(this.renderItem))
    ];
    componentWillLoad() {
        this.showHeader = !!this.el.querySelector(':scope>[slot="header"]');
        this.showFooter = !!this.el.querySelector(':scope>[slot="footer"]');
    }
    render() {
        return (h("ch-dropdown", { buttonLabel: this.buttonLabel, class: this.cssClass || null, expandBehavior: this.expandBehavior, openOnFocus: this.openOnFocus, position: this.position }, h("slot", { name: "action", slot: "action" }), this.showHeader && h("slot", { name: "header", slot: "header" }), this.model != null && this.model.map(this.renderItem), this.showFooter && h("slot", { name: "footer", slot: "footer" })));
    }
    static get is() { return "ch-dropdown-render"; }
    static get originalStyleUrls() {
        return {
            "$": ["dropdown-render.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dropdown-render.css"]
        };
    }
    static get properties() {
        return {
            "buttonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute lets you specify the label for the expandable button.\nImportant for accessibility."
                },
                "attribute": "button-label",
                "reflect": false,
                "defaultValue": "\"Show options\""
            },
            "cssClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-dropdown` element class."
                },
                "attribute": "css-class",
                "reflect": false,
                "defaultValue": "\"dropdown\""
            },
            "expandBehavior": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"Click\" | \"ClickOrHover\"",
                    "resolved": "\"Click\" | \"ClickOrHover\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine which actions on the expandable button display the dropdown\nsection."
                },
                "attribute": "expand-behavior",
                "reflect": false,
                "defaultValue": "\"ClickOrHover\""
            },
            "gxImageConstructor": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(name: string) => any",
                    "resolved": "(name: string) => any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA to implement the Tree View as a UC 2.0 in GeneXus."
                }
            },
            "gxSettings": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA to implement the Tree View as a UC 2.0 in GeneXus."
                },
                "attribute": "gx-settings",
                "reflect": false
            },
            "itemClickCallback": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(\n    event: UIEvent,\n    target: string,\n    itemId: string\n  ) => void",
                    "resolved": "(event: UIEvent, target: string, itemId: string) => void",
                    "references": {
                        "UIEvent": {
                            "location": "global",
                            "id": "global::UIEvent"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This callback is executed when an item is clicked."
                }
            },
            "model": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "DropdownItemModel[]",
                    "resolved": "DropdownItemModel[]",
                    "references": {
                        "DropdownItemModel": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/renders/dropdown/types.ts::DropdownItemModel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property lets you define the model of the ch-dropdown control."
                }
            },
            "openOnFocus": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine if the dropdown section should be opened when the expandable\nbutton of the control is focused."
                },
                "attribute": "open-on-focus",
                "reflect": false,
                "defaultValue": "false"
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DropdownPosition",
                    "resolved": "\"Center_OutsideEnd\" | \"Center_OutsideStart\" | \"InsideEnd_OutsideEnd\" | \"InsideEnd_OutsideStart\" | \"InsideStart_OutsideEnd\" | \"InsideStart_OutsideStart\" | \"OutsideEnd_Center\" | \"OutsideEnd_InsideEnd\" | \"OutsideEnd_InsideStart\" | \"OutsideEnd_OutsideEnd\" | \"OutsideEnd_OutsideStart\" | \"OutsideStart_Center\" | \"OutsideStart_InsideEnd\" | \"OutsideStart_InsideStart\" | \"OutsideStart_OutsideEnd\" | \"OutsideStart_OutsideStart\"",
                    "references": {
                        "DropdownPosition": {
                            "location": "import",
                            "path": "../../dropdown/types",
                            "id": "src/components/dropdown/types.ts::DropdownPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the position of the dropdown section that is placed relative to\nthe expandable button."
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"Center_OutsideEnd\""
            },
            "useGxRender": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA to implement the Tree View as a UC 2.0 in GeneXus."
                },
                "attribute": "use-gx-render",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dropdown-render.js.map
